import { Component, Input, Inject, Injector } from '@angular/core';
import { Location } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../core/animations';

/** Local file */

import { spekwo, spekWalk, spekwoType, toolTip, toastMsg } from '../../../../../../utils/index';

/**Service file */

import { SolutionFormService } from '../../../../solutionForm.service';


// Try this.Passing the function down as props to the child component.

import { WalkCallBodyComponent } from '../../walkCallBody.component';
import { AddSubCategoryPopupComponent } from '../../add-subcategory/addSubCategory.component';

import { ToastComponent } from '../../../../../../common/toast.component';

/**Pipe file */
import { FilterArrayPipe } from '../../../../../../pipesFiles/filter.pipe';
import { FilterExactArrayPipe } from '../../../../../../pipesFiles/filterExactMatch.pipe';
import { FiveDigitRandomNumberPipe } from '../../../../../../pipesFiles/randomNumber.pipe';

/**Pipe file */
import { ReportReviewQueryService } from '../../../../../../queryFiles/index';

@Component({
    selector: 'edit-category',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    animations: fuseAnimations,
    providers: [
        WalkCallBodyComponent,
        FilterArrayPipe,
        FilterExactArrayPipe,
        FiveDigitRandomNumberPipe
    ]
})

export class EditComponent {

    spekwoValues = spekwo;
    spekwoWalkValues = spekWalk;
    spekwoType = spekwoType;
    toolTip = toolTip;
    toastMsg = toastMsg;

    @Input()
    orderType: string;

    insId: string;
    dialogTitle: string;

    category: any;

    enableSave: boolean = true;
    isLoading: boolean = false;

    allSubCategories: subCategories[];
    selectedCategories: ReviewReport[];
    subCategories: any;
    allCategories = [];

    selectedCategory: any;

    mainCategory: string;
    subCategory: string;
    summary: string;
    totalCost: number;
    itemNumber: string;

    currentIndex: number;

    parentComponent: any;

    updateValueSubscription: Subscription;
    wcInsReportIdChangeSubscription: Subscription;

    constructor(
        public injector: Injector,
        private location: Location,
        public dialog: MatDialog,

        private solutionFormService: SolutionFormService,

        public dialogRef: MatDialogRef<EditComponent>,
        public toastComponent: ToastComponent,

        @Inject(MAT_DIALOG_DATA) private receiverData: any,

        public reportReviewQueryService: ReportReviewQueryService
    ) {
        this.dialogTitle = this.spekwoWalkValues.editCategory;
        this.selectedCategory = receiverData.category;
        this.allSubCategories = receiverData.allSubCategories;
        this.selectedCategories = receiverData.selectedCategories;
        this.allCategories = receiverData.allCategories;
        this.currentIndex = receiverData.currentIndex;

        //Based on category,populate sub category
        this.dropdownCategory(this.selectedCategory.mainCategory);
        //Assign initial values
        this.assignValues();

    }

    ngOnInit() {
        /**Get inspection id of order */
        this.wcInsReportIdChangeSubscription = this.solutionFormService.insReportIdChange.subscribe(data => {
            this.insId = data && data.insReportId;
        });

        /**Get Parent compoenent initial values & access functions */
        this.parentComponent = this.injector.get(WalkCallBodyComponent); //Gets initial value alone

    }
    ngOnDestroy() {
        this.wcInsReportIdChangeSubscription && this.wcInsReportIdChangeSubscription.unsubscribe();
        this.updateValueSubscription && this.updateValueSubscription.unsubscribe();
    }

    assignValues() {
        this.mainCategory = this.selectedCategory.mainCategory;
        this.subCategory = this.selectedCategory.subCategory;
        this.summary = this.selectedCategory.summary;
        this.totalCost = this.selectedCategory.totalCost;
        this.itemNumber = this.selectedCategory.itemNumber;
    }

    /**Enable save button once filled value */
    getInputValue(value) {

        if (value) {
            this.enableSave = true;
        }
        else {
            this.enableSave = false;
        }

    }

    /**Based on dropdown selct on category populate sub categories if exist  */
    dropdownCategory(mainCategory) {

        this.subCategories = this.allSubCategories;

        var getMatchId = _.find(this.allCategories, { 'key': mainCategory });

        if (getMatchId) {
            this.subCategories = _.filter(this.subCategories, { 'categoryId': getMatchId.catgoryId });
            this.subCategory = '';
        } else {
            this.subCategories = [];
            this.subCategory = '';
        }

    }

    /** Add new  subcategory value */
    addSubCategory() {

        this.openPopup(this.mainCategory);
    }

    /**open popup for adding sub catgeory */
    openPopup(mainCategory) {

        // Get category id of selected category
        var getMatchId = _.find(this.allCategories, (obj) => {
            return (obj.key).toLowerCase() == mainCategory.toLowerCase();
        });

        // Check category select from dropdown
        if (getMatchId) {

            const dialogRef = this.dialog.open(AddSubCategoryPopupComponent, {
                width: '400px',
                data: {
                    mainCategoryId: getMatchId.catgoryId
                }
            });

            dialogRef.afterClosed().subscribe(result => {

                if (!result) {
                    return;
                }

                const actionType: string = result[0];
                const returnData: subCategories = result[1];
                switch (actionType) {
                    /**
                     * Save
                     */
                    case 'save':

                        this.toastComponent.showToast(toastMsg.addSubCategory);
                        /*Once add refresh sub categories**/
                        this.subCategories.push(returnData);
                        this.allSubCategories.push(returnData);
                        break;

                    /**
                    * Failed
                    */
                    case 'failed':
                        this.toastComponent.showToast(toastMsg.failedReview);
                        break;

                    case 'cancel':
                        break;

                }

            });

        } else {
            this.toastComponent.showToast(toastMsg.warningBeforeReview);
        }

    }
    /**Update Category */
    updateValue() {

        this.isLoading = true;

        var allObjects = {
            mainCategory: this.mainCategory,
            subCategory: this.subCategory,
            summary: this.summary,
            itemNumber: this.itemNumber,
            totalCost: this.totalCost
        }

        this.updateValueSubscription = this.reportReviewQueryService
            .UPDATE_REPORT_REVIEW_FOR_WC(this.selectedCategory.nodeId,
                allObjects)
            .subscribe(() => {
                this.isLoading = false;

                this.dialogRef.close(['edit', allObjects, 'success'])
            }, () => {
                this.dialogRef.close(['edit', allObjects, 'failed'])
            })
    }

}
export interface ReviewReport {
    mainCategory: string;
    subCategory: string;
    summary: string;
    totalCost: any;
}
export interface SummaryReport {
    mainCategory: string;
    subCategory: string;
    summary: string;
    totalCost: any;
    itemNumber: string;
    subCategories: any;
    reviewId: string;
    approve: string;
}
export interface subCategories {
    categoryId: number,
    subCategory: string,
    subId: number
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/walk-call/walk-call-body/list-reports/edit/edit.component.ts